import { AppSidebarMenu } from "@/components/ui/layout/menuSidebar/app-sidebar"
import { MobileTrigger } from "@/components/ui/layout/menuSidebar/mobile-trigger"
import { SidebarInset, SidebarMenuProvider } from "@/components/ui/layout/menuSidebar/sidebar"
import { cn } from "@/modules/lib/utils"

type Props = {
  className?: string
} & React.ComponentProps<"div">

export function AppLayout({ children, className }: Props) {
  return (
    <SidebarMenuProvider>
      <AppSidebarMenu />
      <SidebarInset className={cn(className)}>
        <MobileTrigger />
        {children}
      </SidebarInset>
    </SidebarMenuProvider>
  )
}
